import { baseURL } from "@/general";
import axios from "axios";

const adminApi = axios.create({
    baseURL,
});

export const getSemestresService = async (values) => {
    let token = sessionStorage.getItem("token");
    const config = { headers: { "x-api-key": token, }, };
    try {
        const response = await adminApi.get("/semestre/semestres", config);
        return response;
    } catch (error) {
        const response = error.response;
        return response;
    }
};
